<template>
  <div>
    <head-nav-bar
      title="排房信息"
      :fixed="true"
      rightText="..."
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入房号"
        style="border-bottom:1px solid #f1f1f1;"
        v-model="keyword"
        @search="onSearch"
      />
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell title="房间 1" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
          </van-cell>
          <van-cell title="房间 2" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div class="submit">
        <van-button type="primary" round size="large" @click="onSubmit">
          确认
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
// import searchPopup from "@/components/searchPopup";
import {
  Row,
  Col,
  Radio,
  RadioGroup,
  Button,
  Cell,
  CellGroup,
  Search,
} from "vant";
export default {
  name: "OrderRoomInfo",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Search.name]: Search,
  },
  props: {
    id: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      keyword: "",
      radio: "1",
    };
  },
  model: {},
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    onSearchClick() {},
    onSearch() {},
    onSubmit() {},
  },
};
</script>

<style scoped>
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 5px 16px;
  background-color: #fff;
}
</style>
